import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { SelectProps } from "antd/es/select";
import { Resource } from "../../../api/common";
import useAxios from "axios-hooks";

const buildOptionsElm = (results: []) => {
   return results.map((result: any) => {
      return (
         <Select.Option key={result.key} value={result.value}>
            {result.label}
         </Select.Option>
      );
   });
};

const ProductGroupField: React.FC<any> = ({
   onFieldSelect = () => {},
   categoryId
}) => {
   const [options, setOptions] = useState<SelectProps<object>["options"]>([]);
   const [selectedItems, setSelectedItems] = useState<any>([]);

   const [{ data, loading, error }, refetch] = useAxios(
      { url: `${Resource.path.getCategories}/${categoryId}` },
      { useCache: false, manual: true }
   );

   useEffect(() => {
      if (categoryId) {
         refetch();
      }
   }, [categoryId]);

   useEffect(() => {
      if (data?.data) {
         const { product_groups } = data?.data;

         if (product_groups) {
            const options: any = buildOptionsElm(product_groups);
            setOptions(options);
         }
      }
   }, [data]);

   const onValueChange = (value: any) => {
      setSelectedItems(value);
      onFieldSelect(value);
      console.log(value);
   };

   return (
      <Select
         labelInValue={true}
         size="large"
         placeholder="Select Product Group"
         value={selectedItems}
         onChange={onValueChange}
         style={{ width: "100%" }}>
         {options}
      </Select>
   );
};

export default ProductGroupField;
